angular.module('zc.projects')

.directive 'campaignSteps', ($state) ->
  restrict: 'E'
  scope:
    allValid: '='
    basicForm: '='
    templateForm: '='
    incentiveForm: '='
    botbonnieForm: '='
    policyForm: '='
    timingForm: '='
    scheduleForm: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_steps.html'
  link: (scope, element, attrs) ->
    scope.$state = $state



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_steps.coffee